import { get, post } from './httpClient';
import type { YearEndRolloverResult, ApiResponse } from '../types';

interface WeeklyRevenueParams {
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

interface IncompleteTimesheetsParams {
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export const reportService = {
  // Get weekly revenue data
  getWeeklyRevenue: async (params?: WeeklyRevenueParams): Promise<any> => {
    const response = await get('/db_special/weekly_revenue', { params });
    return response.data;
  },

  // Get incomplete timesheets
  getIncompleteTimesheets: async (params?: IncompleteTimesheetsParams): Promise<any> => {
    const response = await get('/db_special/incomplete_timesheets', { params });
    return response.data;
  },
};

export const adminService = {
  // Execute year-end rollover
  executeYearEndRollover: async (year: string): Promise<ApiResponse<YearEndRolloverResult[]>> => {
    const response = await post<ApiResponse<YearEndRolloverResult[]>>('/admin/year_end_rollover', { year });
    return response.data;
  },

  // Initialize leave accumulation
  initLeaveAccumulation: async (): Promise<ApiResponse> => {
    const response = await post<ApiResponse>('/admin/init_leave_accumulation');
    return response.data;
  },
};
